import React, { useCallback, MouseEventHandler, FC, Ref, CSSProperties, ReactChild, ReactNode } from 'react';
import cn from 'classnames';
import { MenuGroup } from './MenuGroup/MenuGroup';
import { MenuItem } from './MenuItem/MenuItem';
import { Hashmap, StateListbox } from '../../hooks/useListboxState';
require("./Menu.css");
var styles = {
  "Root": "Menu-module-Root_3In"
};
const initialMap = new Map();
const initialObject = {};

/**
 * Вставляет в строку разметку для части этой строки,
 * чтобы выделить подстроку совпадающую с вводом в текстовое поле
 * @param string
 * @param matchIndices
 * @returns string | ReactNode
 */
const splitStringByMatch = (string, matchIndices) => {
  if (!matchIndices || matchIndices.length === 0) return string;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, string.substring(...matchIndices)), string.substring(matchIndices[1]));
};
export const Menu = ({
  checkedKeys,
  className,
  collectionGroups = initialObject,
  collectionOptions = initialMap,
  controlRef,
  groupsKeys = [],
  id,
  innerRef,
  isMultiselectable = false,
  length = 0,
  onChange,
  onKeyDown,
  optionKeys = [],
  selectedKey,
  style = {}
}) => {
  const hendleKeyDown = useCallback(e => {
    if (onKeyDown) {
      onKeyDown(e);
    }
  }, [onKeyDown]);
  const handleMouseDown = useCallback(e => {
    e.preventDefault();
  }, []);
  const renderItem = useCallback(items => {
    if (items.length === 0) return null;
    return items.reduce((acc, optionId) => {
      if (!collectionOptions.get(optionId)?.isVisible) return acc;
      return [...acc, /*#__PURE__*/React.createElement(MenuItem, {
        "aria-posinset": collectionOptions.get(optionId)?.posinset,
        "aria-setsize": length,
        checked: checkedKeys?.includes(optionId),
        description: collectionOptions.get(optionId)?.description,
        disabled: collectionOptions.get(optionId)?.disabled,
        id: optionId,
        key: optionId,
        label: collectionOptions.get(optionId).label,
        onChange: onChange,
        selected: selectedKey === optionId
      }, splitStringByMatch(collectionOptions.get(optionId).label, collectionOptions.get(optionId).matchIndices))];
    }, []);
  }, [checkedKeys, selectedKey, collectionOptions, length, onChange]);
  if (!collectionOptions?.size) return null;
  const isFlat = !Object.keys(collectionGroups).length && collectionOptions?.size > 0;
  return /*#__PURE__*/React.createElement("div", {
    "aria-multiselectable": isMultiselectable,
    className: cn(styles.Root, className),
    id: id,
    onKeyDown: hendleKeyDown,
    onMouseDown: handleMouseDown,
    ref: innerRef || controlRef,
    role: "listbox",
    style: style,
    tabIndex: -1
  }, !isFlat && Object.entries(groupsKeys).map(([groupId, items]) => /*#__PURE__*/React.createElement(MenuGroup, {
    heading: collectionGroups[groupId].heading,
    key: groupId
  }, renderItem(items))), isFlat && renderItem(optionKeys));
};
if (process.env.NODE_ENV !== 'production') {
  Menu.displayName = 'Menu';
}